import e from"styled-components";const i="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=640&h=480&q=80",t=e.div`
	display: flex;
	flex-direction: ${({isMain:e})=>e?"row":"column"};
	align-items: ${({isMain:e})=>e?"end":"start"};
	column-gap: 24px;
	row-gap: 40px;
	padding: 16px;
	border-radius: ${({borderRadius:e})=>e};
	font-family: 'SF Pro Display';
	box-sizing: border-box;
	background-color: ${({theme:e})=>e.bg.card};

	${({hasBorder:e,theme:i})=>e?`border: 0.71px solid ${i.border.black15};`:"box-shadow: 0 0 4px 0 rgba(63, 65, 66, 0.2);"}
`,o=e.div`
	display: flex;
	flex-direction: ${({isMain:e})=>e?"row":"column"};
	align-items: ${({isMain:e})=>e?"center":"start"};
	column-gap: 24px;
	row-gap: 24px;
	width: 100%;
`,a=e.div`
	display: grid;
	grid-template-columns: repeat(3, min-content);
	justify-content: center;
	color: ${({theme:e,color:i})=>i.text[e.name]||"#fff"};
	background: ${({theme:e,color:i})=>i.accent[e.name]||"#1d7afc"};
	width: ${({isMain:e,hasImage:i})=>e||i?"auto":"100%"};
	border-radius: ${({borderRadius:e})=>e};
`,n=e.div`
	display: flex;
	flex-direction: column;
	row-gap: ${({isMain:e,hasImage:i})=>e&&i?15:8}px;
`,r=e.span`
	position: relative;
	font-weight: 600;
	font-size: ${({hasImage:e,isMain:i})=>e?i?32:18:21}px;
	color: ${({theme:e})=>e.text.title};
	word-wrap: break-word;
	line-height: 30px;
	letter-spacing: -0.3px;
`,s=e.span`
	position: relative;
	font-weight: 400;
	font-size: 15px;
	line-height: 18.2px;
	color: #acacac;
	word-wrap: break-word;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: ${({hasImage:e})=>e?3:2};
	-webkit-box-orient: vertical;
`,d=e.div`
	display: flex;
	flex-direction: column;
	row-gap: 3px;
	align-items: center;
	justify-content: center;
	text-align: center;
	border: 1px solid ${({hasBorders:e})=>"#ffffff"+(e?"66":"00")};
	border-top: none;
	border-bottom: none;
	margin: ${({hasImage:e})=>e?15:25}px 0;
	height: fit-content;
`,p=e.div`
	font-weight: 700;
	font-size: 22px;
	line-height: 22px;
	width: 68px;
`,l=e.div`
	min-width: 40px;
	font-weight: 700;
	font-size: 36px;
	line-height: 43px;
	padding: 11px 12px;

	&::after {
		content: '--';
	}
`,x=e.div`
	font-weight: 400;
	font-size: 12px;
	line-height: 15px;
	text-transform: uppercase;
`,c=e.div`
	cursor: pointer;
`,f=e.div`
	display: flex;
	align-items: center;
	column-gap: 6px;
	color: ${({theme:e})=>e.bg.black};
	line-height: 23px;
	font-size: 14px;
	font-weight: 500;
	white-space: nowrap;
	opacity: 0.6;
`,g=e.div`
	max-width: ${({isMain:e})=>e?100:250}px;
	overflow: hidden;
	text-overflow: ellipsis;
`,h=e.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: ${({borderRadius:e})=>e};
	min-width: ${({hasImage:e,isMain:i})=>i?e?"300px":"auto%":"100%"};
	height: ${({hasImage:e})=>e?"185px":"auto"};
	background: ${({image:e,hasImage:t})=>t?`url("${(e||{}).link||i}")`:"transparent"};
	background-size: cover;
	background-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
`;export{o as CountdownContent,t as CountdownWrapper,i as DEFAULT_IMAGE,s as Description,n as DetailsWrapper,p as Digits,l as DigitsPlaceholder,h as ImageWrapper,c as Link,f as LinkButton,g as LinkText,x as Stamp,d as TimeBox,a as TimesWrapper,r as Title};
